var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clients-View-/-Payment-plans",
    transform: "translate(-1272.000000, -348.000000)",
    fill: "var(--tru-primary-color)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(1259.000000, 347.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,1 C16.581722,1 13,4.581722 13,9 C13,13.418278 16.581722,17 21,17 C25.418278,17 29,13.418278 29,9 C28.9948096,4.58387371 25.4161263,1.00519036 21,1 Z M23.0031397,9.33281005 L19.6624804,12.6734694 C19.5744406,12.7621105 19.4546031,12.8118544 19.3296703,12.8116178 C19.1393145,12.8114495 18.9677766,12.6967064 18.8949532,12.5208311 C18.8221299,12.3449558 18.862342,12.1425349 18.9968603,12.0078493 L22.0047096,9 L18.9968603,5.99215071 C18.8708614,5.87474375 18.8189958,5.69792431 18.8616103,5.53105877 C18.9042249,5.36419323 19.0345229,5.23389519 19.2013884,5.19128066 C19.368254,5.14866613 19.5450734,5.20053176 19.6624804,5.32653061 L23.0031397,8.66718995 C23.185073,8.85176759 23.185073,9.14823241 23.0031397,9.33281005 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPayment);
export default ForwardRef;